import './about.css'

export default function AboutSecond(){
    return (
        <div className='about-description'>
            <div className='about-description-heading'>
                <h3>Sarte: Where innovation meets precision.</h3>
            </div>
            <div className='about-description-description'>
                <p>Sarte is a multi-disciplinary enterprise shaping industries through innovation and precision, 
                    elivering enduring structures, impactful brands, and intelligent software solutions.</p>
            </div>
        </div>
    )
}